<template>
  <section class="physical-product-recommend-container">
    <img class="banner" src="../../imgs/product_recommend_banner.png" alt="">
    <ul class="list" v-loading="isLoading">
      <li class="item" v-for="(item, index) in hotList" :key="index" @click="handleToDetail(item)">
        <img class="product_img" :src="item.our_pic_url" alt="">
        <div class="title">

          <!-- 顶部 -->
          <div>
            <p class="_title"><i class="store-logo" :class="[`icon_${item.source}`]"></i>{{item.title}}</p>
            <div class="rank" v-if="item.description === '' ? false : true">
              <i class="blue_star"></i>
              {{item.description}}
            </div>
          </div>

          <!-- 底部 -->
          <div>
            <div class="coupon_box" v-if="item.coupon">
              <img class="coupon_icon" src="../../imgs/icon_juan.png" alt="">
              <p class="coupon_num">¥:{{item.coupon}}</p>
              <p class="information">领券</p>

            </div>
            <div :class="{'no_coupon': item.coupon ? false: true}"  class="after_coupon">
              <p class="_after_coupon">
                {{item.coupon ? '券后' : '单价'}}:
                <span>
                  <i>¥</i>
                  <nr-amount :value="item.coupon ? item.final_price : item.price" has-separator class="number" />
                </span>
              </p>
              <div class="commission">佣金:<span>{{round( (item.source === 2 || item.source === 4 ? item.channel_media_distribution_proportion : item.final_media_distribution_proportion) * 100) }}</span>％</div>
            </div>
          </div>

        </div>
      </li>
    </ul>
    <Empty iconType="2" title="暂无数据" v-if="!hotList.length" />
  </section>
</template>

<script>
import { round } from "@/utils"
import { getYouZanKeGoods } from "@/api/distribution"
export default {
  data() {
    return {
      isLoading: false,
      canScroll: false,
      listParams: {
        pageNum: 1,
        pageSize: 10,
        categoryId: '',
        titleLike: '',
        orderBy: '',
        orderFlag: '',
        source: '',
        directionalFlag: false,
        minPrice: '',
        maxPrice: '',
        minCommissionRate: '',
        maxCommissionRate: '',
        hasDocument: false,
        extraLabel: 2, //传2 为爆品推荐
      }, 
      hotTotal: 0, //爆品总数
      hotList: [], //爆品推荐     
    }
  },  
  methods: {
    round,
    load() {
      this.isLoading = true
      getYouZanKeGoods(this.listParams).then(res=>{
        this.isLoading = false;
        if(res.success) {
          this.hotTotal = res.data.count || 0
          if(this.listParams.pageNum === 1) {
            this.hotList = res.data.goodList || [];
          }else{
            this.hotList = [...this.hotList, ...res.data.goodList || []];
          }
          // 做了滚动处理，但爆品较少，一页就能显示完。
          if (this.hotList.length < this.hotTotal) {
            // 还能滚动
            this.canScroll = true;
          } else {
            // 滚动到底了
            this.canScroll = false;
          }
        }
      }).catch(e=>{
        this.isLoading = false
      })
    },
    //加载更多
    loadMore() {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop; // 向上滚动的那一部分高度
      let clientHeight = document.documentElement.clientHeight; // 屏幕高度也就是当前设备静态下你所看到的视觉高度
      let scrHeight = document.documentElement.scrollHeight || document.body.scrollHeight; // 整个网页的实际高度，兼容Pc端

      if(scrollTop + clientHeight + 700 >= scrHeight){
        if(this.canScroll && !this.isLoading){ //this.isFinished控制滚动是否加载更多
          this.isLoading = true;
          this.listParams.pageNum = this.listParams.pageNum + 1;
          this.load();
        }else{
          return;
        }
      }
    },
    //去详情
    handleToDetail(item) {
      
      if(!this.isNewWindow) {
        this.$router.push({
          name: 'physicalDetail',
          params: {
            id: item.alias
          },
          query: {
            category: item.our_category_id
          }
        })
      }else{
        let { href } = this.$router.resolve({
          name: 'physicalDetail',
          params: {
            id: item.alias
          },
          query: {
            category: item.our_category_id
          }
        })
        let newWindow = window.open('_blank');
        newWindow.location = href
      }
    }
  }, 
  created() {
    this.load()

    window.addEventListener('scroll', this.loadMore);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.loadMore)
  }
}
</script>

<style lang="scss">
.physical-product-recommend-container {
  .banner {
    width: 750px;
    height: 160px;
  }
  .list {
    box-sizing: border-box;
    padding: 32px 28px;
    .item {
      margin-bottom: 48px;
      display: flex;
      .product_img{
        width: 252px;
        height: 252px;
        margin-right: 16px;
        background: rgba(0, 0, 0, 0);
        border-radius: 8px;
      }
      .title {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .store-logo {
          width: 28px;
          height: 28px;
          display: inline-block;
          margin-right: 8px;
            &.icon_1{
              background: url('../../../../assets/imgs/icon_youzan.svg') no-repeat;
            }
            &.icon_2, &.icon_4{
              background: url('../../../../assets/imgs/icon_taobao.svg') no-repeat;
            }
            &.icon_3{
              background: url('../../../../assets/imgs/icon_jd.svg') no-repeat;
            } 
            &.icon_5{
              background: url('../../../../assets/imgs/icon_pdd.svg') no-repeat;
              background-size: cover;
            }                       
        }
        ._title {
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          line-height: 42px;
          font-size: 28px;
          font-weight: 400;
          color: #3E4040;
        }
        .rank {
          width: 416px;
          height: 36px;
          margin-top: 10px;
          background: linear-gradient(270deg, rgba(92, 161, 230, 0) 0%, rgba(81, 138, 194, 0.16) 82%, rgba(92, 161, 230, 0.2) 100%);
          border-radius: 4px;
          font-size: 22px;
          font-weight: 400;
          line-height: 36px;
          color: #5CA1E6;
          .blue_star {
            position: relative;
            top: 2px;
            left: 8px;
            display: inline-block;
            width: 24px;
            height: 24px;
            margin-right: 4px;
            background: url('../../imgs/icon_star.svg') no-repeat;
          }
        }
        .no_coupon {
          margin-top: 80px !important;
          ._after_coupon {
            color: #BABFBF !important;
            span {
              color: #FF7733;         
            }
          }
        }
        .coupon_box {
          display: flex;
          .coupon_icon {
            width: 36px;
            height: 32px;
          }
          .coupon_num {
            padding: 0 15px 0 5px;
            margin-right: 12px;
            min-width: 58px;
            height: 32px;
            line-height: 1.8;
            background: url('../../imgs/icon_juan_box.png');
            background-size: 100% 100%;
            font-size: 20px;
            font-weight: 400;
            color: #FF7733;
          }

          .information {
            padding: 0 4px;
            height: 28px;
            line-height: 1.8;
            background: rgba(255, 119, 51, 0.1);
            border: 2px solid rgba(255, 119, 51, 0.2);
            border-radius: 2px;
            font-size: 20px;
            font-weight: 400;
            color: #FF7733;
          }
        }
        .after_coupon {
          margin-top: 32px;
          display: flex;
          justify-content: space-between;
          ._after_coupon {
            font-size: 22px;
            font-weight: 400;
            line-height: 30px;
            color: #FF7733;
            span {
              font-size: 28px;
              font-weight: bold;
              line-height: 44px;
                i {
                  font-size: 22px;
                  font-weight: 400;                
                }     
            }
          }
          .commission {
            position: relative;
            text-align: center;
            width: 176px;
            height: 40px;
            background: #FF7733;
            border-radius: 8px;
            font-size: 22px;
            font-weight: 400;
            line-height: 30px;
            color: #FFFFFF;
            span {
              font-size: 28px;
              font-weight: bold;
              line-height: 44px;
              color: #FFFFFF;
            }
            &::before {
              content: '';
              position: absolute;
              left: -10px;
              top: 8px;
              width: 0;
              height: 0;
              border-top: 12px solid transparent;
              border-right: 12px solid #FF7733;
              border-bottom: 12px solid transparent;
            }
          }
        }
      }
    }
  }
}
</style>